import { EngagementSurveyReportGroupBy } from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { TeamPickerTeam } from "../team-picker";

export enum EngagementSurveyReportTableType {
  NPS,
  RANGE,
}

export enum EngagementSurveyFilterMatchType {
  MATCH_ALL = "match_all",
}

export enum EngagementSurveyReportFilterType {
  TEAM = "team",
  REPORTS_TO = "reportsTo",
  REPORTS_TO_FULL_TREE = "reportsToFullTree",
  EMPLOYEE_START_DATE = "employeeStartDate",
  LOCATION = "location",
}

export type EngagementSurveyReportFilterItem =
  | {
      type: EngagementSurveyReportFilterType.EMPLOYEE_START_DATE;
      data: (string | null)[];
    }
  | {
      type: EngagementSurveyReportFilterType.TEAM;
      data: TeamPickerTeam[];
    }
  | {
      type: EngagementSurveyReportFilterType.REPORTS_TO;
      data: BasicUser[];
    }
  | {
      type: EngagementSurveyReportFilterType.REPORTS_TO_FULL_TREE;
      data: BasicUser[];
    }
  | {
      type: EngagementSurveyReportFilterType.LOCATION;
      data: string[];
    };

export type EngagementSurveyReportViewOptions = {
  id?: number | null;
  isDirty: boolean;
  name: string;
  filters: {
    type: EngagementSurveyFilterMatchType;
    list: EngagementSurveyReportFilterItem[];
  };
  groupBy: EngagementSurveyReportGroupBy | null;
  hiddenColumns: string[];
};

export type EngagmentSurveyGroupBySelectorItem = {
  key: string;
  label: string;
};

export type EngagementSurveyReportGraphQLFilters = {
  teamIdsFilter: number[];
  managerIdsFilter: number[];
  managerIdsFullTreeFilter: number[];
  employeeStartDateRangeFilter: (string | null)[];
  locationsFilter: string[];
};
